import React from 'react';
import propTypes from 'prop-types';
import classNames from 'classnames';

// constants
import { scriptTypes } from 'constants/scripts';

// components
import ScriptConfig from 'edit/ScriptConfig';

const baseString = 'vra-script-config-container';
const classString = classNames({
  [`${baseString}`]: true
});
let ScriptConfigContainer = ({
  applicationType,
  displayScriptName,
  hasNitrapyrin,
  onChangeNitrapyrin,
  onChangePlantingFertilizerApplication,
  onChangeScriptName,
  onClickScriptConfigViewTrigger,
  onFertilityInputMount,
  onSelectFertilizerProduct,
  onSelectSubstanceType,
  onSelectIncorporationMethodForCropProtection,
  maxDate,
  minDate,
  nitrapyrin,
  plantingPlanParams,
  products,
  resetConfigForFertilityScriptIfNeeded,
  scriptConfigView,
  scriptId,
  scriptType,
  substanceTypeUuid,
  substanceTypeIsNitrogen,
  substanceTypes,
  usingLiquidIsChecked,
  validationResult,
  nitrogenApplicationRateType,
  setNitrogenApplicationRateType,
  showNitrogenApplicationRateTypeSwitch
}) => {
  const checkIfValidBeforeChangeView = (viewToChange) => {
    if (scriptType === scriptTypes.FERTILITY) {
      resetConfigForFertilityScriptIfNeeded({ scriptId });
    }

    onClickScriptConfigViewTrigger(viewToChange);
  };

  return (
    <section className={classString}>
      <ScriptConfig
        applicationType={applicationType}
        displayScriptName={displayScriptName}
        hasNitrapyrin={hasNitrapyrin}
        maxDate={maxDate}
        minDate={minDate}
        nitrogenApplicationRateType={nitrogenApplicationRateType}
        onChangeNitrapyrin={(e) => onChangeNitrapyrin(e, scriptId, nitrapyrin)}
        onChangePlantingFertilizerApplication={
          onChangePlantingFertilizerApplication
        }
        onChangeScriptName={onChangeScriptName}
        onClickScriptConfigViewTrigger={checkIfValidBeforeChangeView}
        onFertilityInputMount={onFertilityInputMount}
        onSelectFertilizerProduct={onSelectFertilizerProduct}
        onSelectIncorporationMethodForCropProtection={(value) =>
          onSelectIncorporationMethodForCropProtection(value, scriptId)
        }
        onSelectSubstanceType={onSelectSubstanceType}
        plantingPlanParams={plantingPlanParams}
        products={products}
        scriptConfigView={scriptConfigView}
        scriptType={scriptType}
        setNitrogenApplicationRateType={setNitrogenApplicationRateType}
        showNitrogenApplicationRateTypeSwitch={
          showNitrogenApplicationRateTypeSwitch
        }
        substanceTypeIsNitrogen={substanceTypeIsNitrogen}
        substanceTypeUuid={substanceTypeUuid}
        substanceTypes={substanceTypes}
        usingLiquidIsChecked={usingLiquidIsChecked}
        validationResult={validationResult}
      />
    </section>
  );
};

ScriptConfigContainer.propTypes = {
  applicationType: propTypes.string.isRequired,
  displayScriptName: propTypes.string.isRequired,
  hasNitrapyrin: propTypes.bool.isRequired,
  maxDate: propTypes.string.isRequired,
  minDate: propTypes.string.isRequired,
  nitrapyrin: propTypes.object,
  nitrogenApplicationRateType: propTypes.string,
  onChangeIsUsingLiquid: propTypes.func,
  onChangeNitrapyrin: propTypes.func.isRequired,
  onChangePlantingFertilizerApplication: propTypes.func,
  onChangeScriptName: propTypes.func.isRequired,
  onClickScriptConfigViewTrigger: propTypes.func,
  onFertilityInputMount: propTypes.func.isRequired,
  onSelectFertilizerProduct: propTypes.func.isRequired,
  onSelectIncorporationMethodForCropProtection: propTypes.func.isRequired,
  onSelectSubstanceType: propTypes.func.isRequired,
  plantingPlanParams: propTypes.object,
  products: propTypes.array.isRequired,
  resetConfigForFertilityScriptIfNeeded: propTypes.func.isRequired,
  scriptConfigView: propTypes.string.isRequired,
  scriptId: propTypes.string.isRequired,
  scriptType: propTypes.string.isRequired,
  setNitrogenApplicationRateType: propTypes.func,
  showNitrogenApplicationRateTypeSwitch: propTypes.bool, // Null is a valid value to pass indicating no substance type, so can't use .isRequired here.
  substanceTypeIsNitrogen: propTypes.bool.isRequired,
  substanceTypeUuid: propTypes.string,
  substanceTypes: propTypes.object.isRequired,
  usingLiquidIsChecked: propTypes.bool.isRequired,
  validationResult: propTypes.object
};

export default ScriptConfigContainer;
